import React, {useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {Modal} from 'react-bootstrap';
import {FormattedMessage} from 'react-intl';
import {useParams} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import * as actions from '../_redux/userDetailsActions';

const PopupUpdateUserStatus = ({data}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const userMongoId = useParams().userId;
  const user = useSelector(
    (state) => state.userDetails.user,
    shallowEqual
  );
  const userIsDisabled = data?.disabled ? data?.disabled : false;
  const handleAction = () => {
    const {email} = user;
    if (userIsDisabled) {
      dispatch(actions.enableUser(userMongoId, email));
    } else {
      dispatch(actions.disableUser(userMongoId, email));
    }
    dispatch(actions.fetchUser({userId: userMongoId}));
    handleCloseModal();
  };

  return (
    <>
      <button
        onClick={handleShowModal}
        className={`btn btn-sm ${userIsDisabled ? 'btn-primary' : 'btn-danger'} font-weight-bold mt-4 d-block mx-auto`}
      >
        {userIsDisabled
          ?  <FormattedMessage
            id="userDetails-personalInfo-disableUser-btn-enable"
            defaultMessage="Enable user"
          />
          : <FormattedMessage
            id="userDetails-personalInfo-disableUser-btn-disable"
            defaultMessage="Disable user"
          />
        }
      </button>
      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <div className={'p-6'}>
          <Modal.Title className={`${userIsDisabled ? 'text-primary' : 'text-danger'} text-center mb-4`}>
            {userIsDisabled
              ? <FormattedMessage
                id="userDetails-personalInfo-enableUser-are-you-sure"
                defaultMessage="Are you sure you want to enable the user?"
              />
              : <FormattedMessage
                id="userDetails-personalInfo-disableUser-are-you-sure"
                defaultMessage="Are you sure you want to disable the user?"
              />
            }
            <div>{[data.firstName, data.lastName].filter(Boolean).join(' ')}</div>
          </Modal.Title>
          <div className={'d-flex justify-content-center'}>
            <Button size="sm" className={'w-100px'} variant="secondary" onClick={handleCloseModal}>
              <FormattedMessage
                id="label-button-cancel"
                defaultMessage="Cancel"
              />
            </Button>
            <Button size="sm" className={'w-100px ml-8'} variant="primary" onClick={handleAction}>
              <FormattedMessage
                id="label-button-send"
                defaultMessage="OK"
              />
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PopupUpdateUserStatus;
